module.exports = function getResource(label, vars = []) {
    const resources = {
        shippingAutoReplenishMessage: 'Les options d’expédition express ne s’applique qu’à la première livraison. Les articles à réapprovisionnement automatique subséquents arriveront par expédition standard.',
        gotIt: 'OK'
    };

    return resources[label];
};
